import { ExposureDirectionType } from 'data/types';

export const ALL_DIRECTIONS: ExposureDirectionType[] = [
  'North',
  'North East',
  'East',
  'South East',
  'South',
  'South West',
  'West',
  'North West'
];

export function rotateExposure(
  exposure: string,
  delta: number
): ExposureDirectionType | undefined {
  const exposureIndex = ALL_DIRECTIONS.indexOf(
    exposure as ExposureDirectionType
  );
  if (exposureIndex === -1) return undefined;

  const rotatedIndex = (((exposureIndex - delta) % 8) + 8) % 8;
  return ALL_DIRECTIONS[rotatedIndex];
}

export function getOrientationDelta(
  oldOrientation: string,
  newOrientation: string
): number | undefined {
  const oldIndex = ALL_DIRECTIONS.indexOf(
    oldOrientation as ExposureDirectionType
  );
  const newIndex = ALL_DIRECTIONS.indexOf(
    newOrientation as ExposureDirectionType
  );
  if (oldIndex === -1 || newIndex === -1) return undefined;
  return newIndex - oldIndex;
}
